var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMergePdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 159,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9213_2448)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1395 78.7158C14.2494 58.5052 38.3189 43.2752 66.7157 33.7036C95.3056 24.0669 131.3 18.6511 164.075 28.1778C195.098 37.1953 206.435 58.469 217.285 77.4696C227.178 94.7956 239.339 115.202 220.957 127.794C203.642 139.654 169.178 129.687 140.969 129.745C114.864 129.798 89.1158 137.328 66.2025 128.109C37.4903 116.557 14.0352 97.8996 14.1395 78.7158Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.214 69.4545C132.214 69.9736 131.793 70.3945 131.274 70.3945L120.94 70.3945C120.421 70.3945 120 70.8153 120 71.3345L120 87.2955C120 87.8147 120.421 88.2355 120.94 88.2355L131.274 88.2355C131.793 88.2355 132.214 88.6564 132.214 89.1755L132.214 93.4321C132.214 94.308 133.307 94.7079 133.872 94.039L145.807 79.9219C146.103 79.5715 146.103 79.0585 145.807 78.7081L133.872 64.591C133.307 63.9221 132.214 64.322 132.214 65.1979L132.214 69.4545Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.448529 96.1286V27.0184C0.448529 25.035 2.00781 23.4485 3.9056 23.4485H44.1992L60.5045 40.2248V96.1286C60.5045 98.112 58.9452 99.6985 57.0474 99.6985H3.9056C2.00858 99.6985 0.448529 98.1128 0.448529 96.1286Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 0.897059
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.61943,
    y: 74.5809,
    width: 45.7143,
    height: 18.8382,
    rx: 1.96071,
    fill: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.61943,
    y: 74.5809,
    width: 45.7143,
    height: 18.8382,
    rx: 1.96071,
    stroke: "#D2294B",
    strokeWidth: 0.897059
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6348 88.0157V79.9849H23.2817C24.1727 79.9849 24.8598 80.2127 25.343 80.6683C25.8263 81.1164 26.0679 81.7429 26.0679 82.5479C26.0679 83.3529 25.8263 83.9832 25.343 84.4388C24.8598 84.8945 24.1727 85.1223 23.2817 85.1223H21.3903V88.0157H19.6348ZM21.3903 83.7554H22.9872C23.916 83.7554 24.3803 83.3529 24.3803 82.5479C24.3803 81.7581 23.916 81.3632 22.9872 81.3632H21.3903V83.7554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1559 88.0157V79.9849H30.2818C31.6409 79.9849 32.6943 80.3342 33.4418 81.0329C34.1893 81.7239 34.563 82.7112 34.563 83.9946C34.563 85.278 34.1893 86.269 33.4418 86.9677C32.6943 87.6663 31.6409 88.0157 30.2818 88.0157H27.1559ZM28.9114 86.569H30.1799C31.8788 86.569 32.7282 85.7109 32.7282 83.9946C32.7282 82.2859 31.8788 81.4315 30.1799 81.4315H28.9114V86.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9268 88.0157V79.9849H41.318V81.3632H37.6823V83.3225H41.0688V84.7008H37.6823V88.0157H35.9268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7648 45.8748H50.2411C50.9843 45.8748 51.5867 46.4772 51.5867 47.2204V49.0145C51.5867 49.7577 50.9843 50.3601 50.2411 50.3601H10.7648C10.0217 50.3601 9.41923 49.7577 9.41923 49.0145V47.2204C9.41923 46.4772 10.0217 45.8748 10.7648 45.8748Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.897059
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7648 54.8455H50.2411C50.9843 54.8455 51.5867 55.4479 51.5867 56.1911V57.9852C51.5867 58.7284 50.9843 59.3308 50.2411 59.3308H10.7648C10.0217 59.3308 9.41923 58.7284 9.41923 57.9852V56.1911C9.41923 55.4479 10.0217 54.8455 10.7648 54.8455Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.897059
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7648 63.8157H50.2411C50.9843 63.8157 51.5867 64.4182 51.5867 65.1613V66.9554C51.5867 67.6986 50.9843 68.301 50.2411 68.301H10.7648C10.0217 68.301 9.41923 67.6986 9.41923 66.9554V65.1613C9.41923 64.4182 10.0217 63.8157 10.7648 63.8157Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.897059
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.0384 36.0967V24.1088L59.9424 39.5157H48.3311C46.5268 39.5157 45.0384 37.9996 45.0384 36.0967Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 0.897059
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5058 131.468V53.5316C32.5058 51.2949 34.2642 49.5058 36.4044 49.5058H81.8442L100.232 68.4247V131.468C100.232 133.705 98.4735 135.494 96.3333 135.494H36.4044C34.2651 135.494 32.5058 133.706 32.5058 131.468Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 1.01163
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5927,
    y: 107.168,
    width: 51.5527,
    height: 21.2442,
    rx: 2.21113,
    fill: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5927,
    y: 107.168,
    width: 51.5527,
    height: 21.2442,
    rx: 2.21113,
    stroke: "#D2294B",
    strokeWidth: 1.01163
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1431 122.319V113.262H58.2558C59.2605 113.262 60.0354 113.519 60.5804 114.033C61.1253 114.538 61.3978 115.245 61.3978 116.153C61.3978 117.06 61.1253 117.771 60.5804 118.285C60.0354 118.799 59.2605 119.056 58.2558 119.056H56.1228V122.319H54.1431ZM56.1228 117.514H57.9237C58.971 117.514 59.4947 117.06 59.4947 116.153C59.4947 115.262 58.971 114.817 57.9237 114.817H56.1228V117.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6247 122.319V113.262H66.1499C67.6826 113.262 68.8705 113.656 69.7134 114.444C70.5564 115.223 70.9779 116.337 70.9779 117.784C70.9779 119.231 70.5564 120.349 69.7134 121.137C68.8705 121.925 67.6826 122.319 66.1499 122.319H62.6247ZM64.6045 120.687H66.035C67.9508 120.687 68.9088 119.719 68.9088 117.784C68.9088 115.857 67.9508 114.894 66.035 114.894H64.6045V120.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5159 122.319V113.262H78.5956V114.817H74.4956V117.026H78.3146V118.58H74.4956V122.319H72.5159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1395 74.7963H88.6575C89.4956 74.7963 90.175 75.4757 90.175 76.3138V78.337C90.175 79.1751 89.4956 79.8545 88.6575 79.8545H44.1395C43.3014 79.8545 42.622 79.1751 42.622 78.337V76.3138C42.622 75.4757 43.3014 74.7963 44.1395 74.7963Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.01163
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1395 84.9126H88.6575C89.4956 84.9126 90.175 85.5919 90.175 86.43V88.4532C90.175 89.2913 89.4956 89.9707 88.6575 89.9707H44.1395C43.3014 89.9707 42.622 89.2913 42.622 88.4532V86.43C42.622 85.5919 43.3014 84.9126 44.1395 84.9126Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.01163
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1395 95.0288H88.6575C89.4956 95.0288 90.175 95.7081 90.175 96.5462V98.5695C90.175 99.4075 89.4956 100.087 88.6575 100.087H44.1395C43.3014 100.087 42.622 99.4075 42.622 98.5695V96.5462C42.622 95.7081 43.3014 95.0288 44.1395 95.0288Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.01163
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.7905 63.7694V50.2504L99.598 67.6251H86.5038C84.469 67.6251 82.7905 65.9153 82.7905 63.7694Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 1.01163
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 128.298V29.7312C161.64 26.9024 163.864 24.6397 166.57 24.6397H224.038L247.293 48.5665V128.298C247.293 131.127 245.069 133.39 242.363 133.39H166.57C163.865 133.39 161.64 131.128 161.64 128.298Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.867,
    y: 97.566,
    width: 65.199,
    height: 26.8676,
    rx: 2.79643,
    fill: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.867,
    y: 97.566,
    width: 65.199,
    height: 26.8676,
    rx: 2.79643,
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.004 116.727V105.273H194.205C195.476 105.273 196.456 105.598 197.145 106.248C197.834 106.887 198.179 107.78 198.179 108.928C198.179 110.076 197.834 110.975 197.145 111.625C196.456 112.275 195.476 112.6 194.205 112.6H191.508V116.727H189.004ZM191.508 110.651H193.785C195.11 110.651 195.772 110.076 195.772 108.928C195.772 107.802 195.11 107.239 193.785 107.239H191.508V110.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.731 116.727V105.273H204.189C206.127 105.273 207.63 105.771 208.696 106.768C209.762 107.753 210.295 109.161 210.295 110.992C210.295 112.822 209.762 114.236 208.696 115.232C207.63 116.229 206.127 116.727 204.189 116.727H199.731ZM202.235 114.663H204.044C206.467 114.663 207.678 113.44 207.678 110.992C207.678 108.555 206.467 107.336 204.044 107.336H202.235V114.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.24 116.727V105.273H219.929V107.239H214.744V110.033H219.574V111.999H214.744V116.727H212.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.235 42.6789V25.5814L246.491 47.5552H229.931C227.358 47.5552 225.235 45.3929 225.235 42.6789Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182 56.6251H228C228.751 56.6251 229.36 57.2341 229.36 57.9854V61.6007C229.36 62.352 228.751 62.961 228 62.961H182C181.249 62.961 180.64 62.352 180.64 61.6007V57.9854C180.64 57.2341 181.249 56.6251 182 56.6251Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 69.3174H228C228.751 69.3174 229.36 69.9265 229.36 70.6777V74.2931C229.36 75.0444 228.751 75.6534 228 75.6534H182C181.249 75.6534 180.64 75.0444 180.64 74.2931V70.6777C180.64 69.9265 181.249 69.3174 182 69.3174Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 82.0098H228C228.751 82.0098 229.36 82.6188 229.36 83.3701V86.9855C229.36 87.7367 228.751 88.3458 228 88.3458H182C181.249 88.3458 180.64 87.7367 180.64 86.9855V83.3701C180.64 82.6188 181.249 82.0098 182 82.0098Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9213_2448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 159,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMergePdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/merge-pdf.d2adde4d27ad0a93935cbfb0ee4aeb86.svg";